import { render, staticRenderFns } from "./AdFormBanner.vue?vue&type=template&id=3866d084"
import script from "./AdFormBanner.vue?vue&type=script&lang=ts"
export * from "./AdFormBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports